export default "__VITE_ASSET__k68$O3MU__"